import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-purple-600 text-white" data-id="9dcslm2q1" data-path="src/components/home/CTASection.tsx">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="0zbwxld29" data-path="src/components/home/CTASection.tsx">
        <div className="max-w-4xl mx-auto text-center" data-id="zjqdrkrrw" data-path="src/components/home/CTASection.tsx">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="9u0e7u8xu" data-path="src/components/home/CTASection.tsx">
            Ready to Transform Your Business with AI Automation?
          </h2>
          <p className="text-lg text-blue-100 mb-8 max-w-3xl mx-auto" data-id="djv1w4nha" data-path="src/components/home/CTASection.tsx">
            Join hundreds of businesses that have revolutionized their operations with our custom AI solutions. 
            Connect with us today and discover how we can help you save time, reduce costs, and improve efficiency.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="7b4d8973z" data-path="src/components/home/CTASection.tsx">
            <Button asChild size="lg" className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white" data-id="85srxqv6s" data-path="src/components/home/CTASection.tsx">
              <Link to="/contact" data-id="ez79n75d0" data-path="src/components/home/CTASection.tsx">Get Started Today</Link>
            </Button>
            <Button asChild size="lg" className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white" data-id="zvmxrcw97" data-path="src/components/home/CTASection.tsx">
              <Link to="/contact?type=quote" data-id="27v69gs1k" data-path="src/components/home/CTASection.tsx">Request a Quote</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>);

}